<template>
  <a-spin
    :spinning="isLoading"
    class="custom-spinner"
    style="height: 100vh; top: 20%"
  >
    <administrator-project-layout :model="model">
      <template #underInfo>
        <div class="administrator-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <a-col class="project-indexes" v-if="projectIndexesIsVisible" :span="20">
        <div>
          <h3>Показатели</h3>
          <div class="description"></div>

          <portfolio-indexes-grid
            :disabled="true"
            :briefcases="briefcases"
            :hide-save-button="true"
          />
        </div>
      </a-col>
    </administrator-project-layout>
  </a-spin>
</template>

<script setup>
  import { computed, onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import { PROJECT_STATUS_DRAFT } from '@/api/models/ProjectStatus';
  import PortfolioIndexesGrid from '@/components/projects/portfolio/components/PorfolioIndexesGrid.vue';
  import AdministratorProjectLayout from '@/views/administrator/projects/components/AdministratorProjectLayout.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: 'Новый проект',
    description: '',
    projectType: '',
    requestId: null,
    status: null,
    projectStatusId: null,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });

  const briefcases = ref([]);
  const isLoading = ref(false);
  const projectIndexesIsVisible = computed(
    () => model.projectStatusId !== PROJECT_STATUS_DRAFT
  );

  onMounted(async () => {
    await getModel();
    await getPortfolioIndexes();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.leaderPage.view(route.params.id);
      model.id = response.project.id;
      model.name = response.project.name;
      model.number = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.projectStatusId = response.project.projectStatusId;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getPortfolioIndexes = async () => {
    try {
      const response = await api.briefcase.administratorProjectIndexes(
        new URLSearchParams({
          projectId: route.params.id,
        })
      );
      briefcases.value = response.briefcases;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .administrator-project__common-progress {
    margin-top: 42px;
  }

  .project-indexes {
    margin-top: 10px;
    padding-bottom: 100px;

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    h4 {
      font-size: 14px;
      margin: 30px 0 6px;

      &.disabled {
        color: $color-bg-status-new !important;
      }
    }

    .description {
      font-family: 'Nunito Sans', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      max-width: 678px;
    }
  }
</style>
